var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editable-text',{attrs:{"no-data":_vm.$t('common.no_label'),"multi-select-options":_vm.tagOptions,"new-tag":_vm.newTag},on:{"add-tag":_vm.createTag,"confirm":_vm.saveTags},model:{value:(_vm.newTags),callback:function ($$v) {_vm.newTags=$$v},expression:"newTags"}})
}
var staticRenderFns = []

export { render, staticRenderFns }